"use client";
import { CardBlock } from "@digdir/designsystemet-react";
import { Card as CardParent } from "./card.js";
/**
 * Card component to present content in a structured way.
 *
 * @example
 * <Card>
 *  <Card.Block>Header</Card.Block>
 *  <Card.Block>Content</Card.Block>
 *  <Card.Block>Footer</Card.Block>
 * </Card>
 */
const Card = Object.assign(CardParent, {
    Block: CardBlock,
});
Card.Block.displayName = "Card.Block";
export { Card, CardBlock };
//# sourceMappingURL=index.js.map